/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SubscriptionType {
  badgeId?: number;
  businessUnitId?: number;
  cycle?: number;
  dateCreated?: Date;
  dateUpdated?: Date;
  editionCount?: number;
  imageURL?: string;
  installments?: number;
  isActive?: boolean;
  isVisible?: boolean;
  liveloPoints?: number;
  name?: string;
  price?: number;
  recurrenceMonths?: number;
  restrictedSubscriptionId?: number;
  rewardPoints?: number;
  subscriptionId?: number;
  subscriptionTypeId?: number;
  summary?: string;
}
